import { getLanguage } from "../utils";
import { i18n } from "@euroland/libs";

const locale = getLanguage();
i18n.load(locale, window.appSettings.translations);
